
import React from 'react';
import './assets/css/output.css';
import Login from './authentication/Login';
import Menu from './menu/Menu';
import BottomMenu from './menu/BottomMenu';
import Dashboard from './dashboard/Dashboard';

import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useUser, isManager, isAdmin, isChief, extractIds, isAgent } from './contexts/UserContext';
import Sites from './dashboard/sites/Sites';
import Clients from './dashboard/clients/Clients';
import Silos from './dashboard/silos/Silos';
import Machines from './dashboard/machines/Machines';
import Composants from './dashboard/composants/Composants';
import NotFound from './routes/NotFound';
import RapportsMaintenance from './maintenance/RapportsMaintenance';
import ListOperateurs from './dashboard/operateurs/ListOperateurs';
import ListUtilisateurs from './dashboard/utilisateurs/ListUtilisateurs';
import Loader from './components/Loader';
import ModeMaintenance from './maintenance/ModeMaintenance';


function App() {

  const user = useUser();

  const redirectPath = () => {
    if(user.user != null){

      if(isAdmin(user.user)){
        return '/clients';
      }

      //admin n'a pas ce champs là
      const { client_id } = extractIds(user.user.userData.clientId.path);

      return `/client/${client_id}`;
    }
  };

  if (user.isLoading) {
    return <div className='flex m-auto'><Loader /></div>; // Affiche un loader
  }

  return (
    <Router>
      <Menu connected={user.user != null}/>

      {/* Contenu de la page */}
      
      {user.user == null ? (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/connexion" element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<Dashboard />}>
            <Route index element={<Navigate to={redirectPath()} replace />}/>
            {isAdmin(user.user) ? (
              <Route path="/clients" element={<Clients/>} />
            ) : null }
            {isAdmin(user.user) ? (
              <Route path="/utilisateurs" element={<ListUtilisateurs/>} />
            ) : null }
            {isManager(user.user) ? (
              <Route path="/operateurs" element={<ListOperateurs />} />
            ) : null }
            <Route path="/client/:client_id" element={<Sites/>} />
            <Route path="/client/:client_id/site/:site_id" element={<Silos/>} />
            <Route path="/client/:client_id/site/:site_id/silo/:silo_id" element={<Machines/>} />
            <Route path="/client/:client_id/site/:site_id/silo/:silo_id/machine/:machine_id" element={<Composants/>} />
          </Route>
          {isChief(user.user) || isManager(user.user) ? (
            <Route path="/maintenance" element={<RapportsMaintenance />} />
          ) : null }
          {isAgent(user.user) ? (
            <Route path="/mode-maintenance/:client_id/:site_id/:silo_id/:machine_id" element={<ModeMaintenance />} />
          ) : null }
          <Route path="*" element={<NotFound />} />
        </Routes>
      )}
      <BottomMenu />
    </Router>
  );
}


export default App;
